import { render, staticRenderFns } from "./StockQualityHoldsListDialog.vue?vue&type=template&id=59b6b462"
import script from "./StockQualityHoldsListDialog.vue?vue&type=script&lang=js"
export * from "./StockQualityHoldsListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports